<template>
    <div class="new-applicant">
        <div class="stb-modal-container">
            <div class="stb-modal" @click="hide_overlay">
                <div class="stb-modal-content">
                    <h2>Asd</h2>
                    <input type="text">
                </div>
            </div>
            <div class="stb-modal-overlay"></div>
        </div>
    </div>
</template>

<style lang="scss">
.stb-modal-container {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;

    .stb-modal-overlay {
        position: fixed;
        width: 100%;
        height: 100%;
        background: rgba(50, 50, 50, 0.5);
    }
    .stb-modal {
        position: absolute;
        width: 100vw;
        height: 100vh;
        z-index: 10000;
        text-align: center;
        .stb-modal-content {
            max-width: 50em;
            background: #fff;
            margin: 0 auto;
            margin-top: 10em;
        }
    }
}
</style>

<script>
export default {
    data() {
        return {
        }
    },
    methods: {
        create_token() {
        },
        hide_overlay() {
            console.log('hide_overlay')
            this.$router.back();
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/pages/new-applicant.vue